import { render, staticRenderFns } from "./Indicator.vue?vue&type=template&id=72ceabde&"
import script from "./Indicator.vue?vue&type=script&lang=js&"
export * from "./Indicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72ceabde')) {
      api.createRecord('72ceabde', component.options)
    } else {
      api.reload('72ceabde', component.options)
    }
    module.hot.accept("./Indicator.vue?vue&type=template&id=72ceabde&", function () {
      api.rerender('72ceabde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/dashboard/views/components/Indicator.vue"
export default component.exports